// component/FiltrerTransactionModal.js
import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  ButtonGroup,
} from "reactstrap";
import '../utils/detail.css';
const FiltrerMerchentModal = ({ isOpen, toggle, onApply, countries = [] }) => {
  const [active, setActive] = useState("");
  const [selectedCountrie, setSelectedCountrie] = useState("");
  const [createdDate, setCreatedDate] = useState("")
  const [approvalDate, setApprovalDate] = useState("")
  const applyFilters = () => {
    onApply({
      active,
      countrie: selectedCountrie,
      createdDate,
      approvalDate,
    });
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} contentClassName="custom-modal-siMerchent">
      <ModalHeader toggle={toggle} className="custom-modal-header"style={{color:'#000000'}}>
        Filtrer
      </ModalHeader>
      <ModalBody>
    <div className=" ">
   <div className="d-flex align-items-center me-3">
    <label className=" mb-0 me-2 lanel">Statut</label>
    <div style={{ width: "100%", border:'1px solid #0000001A' }}></div>
  </div>
  <ButtonGroup className="w-100 ">
   <Button
  style={{
    backgroundColor: active === "" ? "#3761FF14" : "#0000000F",
    color: active === "" ? "#3761FF" : "#000000",
    border:active ===""? "1px solid #3761FF14": "1px solid #0000000F",
    fontWeight: active === "" ? 500 : 400,
    margin: "10px",
    borderRadius: "6px",
    fontSize:'14px'
  }}
  onClick={() => setActive("")}
>
  Tous
</Button>
    <Button
     style={{
        backgroundColor: active === true? "#EBFFEA" : "#0000000F",
        color: active === true ? "#349C32" : "#000000",
        border:active === true? "1px solid #EBFFEA": "1px solid #0000000F",
        fontWeight: active === true ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
        fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setActive(true)}
    >
      Actif
    </Button>
    <Button
     style={{
        backgroundColor: active === false ? "#FFF0F0" : "#0000000F",
        color: active === false ? "#E32727" : "#000000",
        border:active === false? "1px solid #FFF0F0": "1px solid #0000000F",
        fontWeight: active === false ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
         fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setActive(false)}
    >
      Inactif
    </Button>
  </ButtonGroup>
  </div>
       <div className="mb-3">
         <div className="d-flex align-items-center me-3">
        <label className=" mb-0 me-2 lanel">Date de création</label>
        <div style={{ width: "100%", border:'1px solid #0000001A' }}></div>
      </div>
      <div className="form-date-field">

        <FormGroup>
        <Input
          type="date"
          value={createdDate}
          onChange={(e) => setCreatedDate(e.target.value)}
        />
      </FormGroup>
      </div>
       </div> 
       <Button
  className="button apply-filter-btn"
  onClick={applyFilters}
>
  Appliquer le filtre
</Button>
</ModalBody>
</Modal>
  );
};

export default FiltrerMerchentModal;
